import { render, staticRenderFns } from "./MyTeam.vue?vue&type=template&id=6a891b0b&scoped=true&"
import script from "./MyTeam.vue?vue&type=script&lang=js&"
export * from "./MyTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a891b0b",
  null
  
)

export default component.exports